import classNames from 'classnames';
import type { SkeletonGradientBackgroundProps } from './types';

const SkeletonGradientBackground = ({
  isShow,
  customClassName = undefined,
}: SkeletonGradientBackgroundProps) =>
  isShow && <div className={classNames('skeleton-gradient-background', customClassName)} />;

export default SkeletonGradientBackground;
